import React from 'react';
import { Col, Form, InputNumber, Row, Select, Typography } from 'antd';
import ModalForm from 'components/modal-form/modal-form.component';
import { PublishToMLFragmentProps } from './interfaces';
import { usePublishToMLController } from './publish-to-ml.controller';
import { ML_CATEGORIES, ML_LISTING_TYPES } from 'services/sales/sale.dto';

const categoryOptions = Object.entries(ML_CATEGORIES).map(([value, label]) => ({ value, label }));

export const PublishToMLFragment: React.FC<PublishToMLFragmentProps> = (props) => {
    const { useController = usePublishToMLController } = props;
    const controller = useController(props);

    return (
        <ModalForm
            title="Publicar en MercadoLibre"
            isvisible={props.isVisible}
            onCancel={props.onCancel}
            onFinish={controller.onFormSubmit}
            form={controller.form}
            isLoading={controller.isLoading}
            layout="vertical"
            okButtonLabel="Publicar"
        >
            <Typography.Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
                Completá los datos para publicar la propiedad en MercadoLibre.
            </Typography.Text>
            <Row gutter={12}>
                <Col xs={24} md={12}>
                    <Form.Item
                        label="Categoría"
                        name="mlCategoryId"
                        rules={[{ required: true, message: 'Seleccioná una categoría' }]}
                    >
                        <Select options={categoryOptions} placeholder="Seleccionar categoría" />
                    </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                    <Form.Item
                        label="Tipo de publicación"
                        name="listingTypeId"
                        rules={[{ required: true, message: 'Seleccioná el tipo de publicación' }]}
                    >
                        <Select options={ML_LISTING_TYPES} placeholder="Seleccionar tipo" />
                    </Form.Item>
                </Col>
                <Col xs={24} md={8}>
                    <Form.Item
                        label="Provincia"
                        name="mlStateId"
                        rules={[{ required: true, message: 'Seleccioná una provincia' }]}
                    >
                        <Select
                            showSearch
                            optionFilterProp="label"
                            loading={controller.isLoadingStates}
                            options={controller.stateOptions}
                            placeholder="Seleccionar provincia"
                            onChange={controller.onStateChange}
                        />
                    </Form.Item>
                </Col>
                <Col xs={24} md={8}>
                    <Form.Item
                        label="Ciudad"
                        name="mlCityId"
                        rules={[{ required: true, message: 'Seleccioná una ciudad' }]}
                    >
                        <Select
                            showSearch
                            optionFilterProp="label"
                            loading={controller.isLoadingCities}
                            options={controller.cityOptions}
                            placeholder="Seleccionar ciudad"
                            disabled={controller.cityOptions.length === 0}
                            onChange={controller.onCityChange}
                        />
                    </Form.Item>
                </Col>
                <Col xs={24} md={8}>
                    <Form.Item
                        label="Barrio"
                        name="mlNeighborhoodId"
                        rules={[{ required: true, message: 'Seleccioná un barrio' }]}
                    >
                        <Select
                            showSearch
                            optionFilterProp="label"
                            loading={controller.isLoadingNeighborhoods}
                            options={controller.neighborhoodOptions}
                            placeholder="Seleccionar barrio"
                            disabled={controller.neighborhoodOptions.length === 0}
                        />
                    </Form.Item>
                </Col>
                <Col xs={24} md={8}>
                    <Form.Item label="Ambientes" name="rooms">
                        <InputNumber style={{ width: '100%' }} min={0} />
                    </Form.Item>
                </Col>
                <Col xs={24} md={8}>
                    <Form.Item label="Baños" name="bathRooms">
                        <InputNumber style={{ width: '100%' }} min={0} />
                    </Form.Item>
                </Col>
                <Col xs={24} md={8}>
                    <Form.Item label="Cocheras" name="parkingLots">
                        <InputNumber style={{ width: '100%' }} min={0} />
                    </Form.Item>
                </Col>
            </Row>
        </ModalForm>
    );
};
